import {useEffect, useState} from "react";
import {IoMdVolumeHigh, IoMdVolumeLow, IoMdVolumeOff} from "react-icons/io";
import {BsMusicNoteList} from "react-icons/bs";

const Options = (props) => {
    const audioRef = props.audioRef;
    const [volume, setVolume] = useState(8);
    const [muteVolume, setMuteVolume] = useState(false);
    const tracklistOpen = props.tracklistOpen;
    const setTracklistOpen = props.setTracklistOpen;

    useEffect(() => {
        if (audioRef) {
            audioRef.current.volume = volume / 100;
        }
    }, [volume, audioRef]);

    useEffect(() => {
        if (audioRef) {
            audioRef.current.volume = volume / 100;
            audioRef.current.muted = muteVolume;
        }
    }, [volume, audioRef, muteVolume]);

    const toggleTracklist = () => {
        setTracklistOpen(!tracklistOpen);
        const image = document.querySelector(".audio-image2");
        !tracklistOpen ? image.style.filter = "blur(4px)" : image.style.filter = "";
    }



    return (
        <div className="Audioplayer-options2">
            <div className="volume2">
                <button onClick={() => setMuteVolume((prev) => !prev)}>
                    {muteVolume || volume < 1 ? (
                        <IoMdVolumeOff />
                    ) : volume < 6 ? (
                        <IoMdVolumeLow />
                    ) : (
                        <IoMdVolumeHigh />
                    )}
                </button>
                <input
                    className="volume-range2"
                    type="range"
                    min={0}
                    max={10}
                    value={volume}
                    onChange={(e) => setVolume(e.target.value)}
                    style={{
                        background: `linear-gradient(to right, white ${volume}0%, #ccc ${volume}0%)`,
                    }}
                />
            </div>
            <div className="playlist">
                <button><BsMusicNoteList onClick={toggleTracklist} style={{fill : tracklistOpen? "#F50" : "#F1F3F4" }}/></button>
            </div>
        </div>
    )
}

export default Options;